
export const splitStringByNewLine = (str: string): string[] => {
    return str.split(/\r?\n/);
}